import { useCallback } from 'react';
import axios from '@helpers/axios';
import { REVCAT_BILLING_KEY } from '@constants/keys';
import { getRevenueCatUserId } from '@helpers/utils/userPlayerUtils';
import { Purchases } from '@revenuecat/purchases-js';

const useConfigureRevenueCatSDK = () => {
  const initRevenueCat = useCallback(async (shdUserId: string) => {
    const isIntialized = Purchases.isConfigured();
    if (!isIntialized) {
      const purchases = Purchases.configure({
        apiKey: REVCAT_BILLING_KEY || '',
        appUserId: getRevenueCatUserId(shdUserId),
      });
      // update the environment for the user
      // ok if this fails
      axios.post(
        `/api/revenuecat/customers/${getRevenueCatUserId(
          shdUserId
        )}/environment`,
        { environment: import.meta.env.MODE }
      );
      return purchases;
    }
  }, []);
  return { initRevenueCat };
};

export default useConfigureRevenueCatSDK;
